import { atom } from "recoil";

const currentListId = atom({
    key: 'currentListId',
    default: ' '
  });

  const loggedUser = atom({
    key: 'loggedUser',
    default: {
      uid: ' ',
      displayName: ' ',
      photoURL: ' '
    }
  });

export { currentListId, loggedUser }